
import { newModalFromString } from '../components/modal';
import FindInStore from '../product/findinstore';
import StoreHours from 'storeLocator/storeHours';

export class BopisHelpers {
    run () {
        if (this.isBopisOnlyActive()) {
            this.bindCartEvents();
            this.clickOnAccordion();
            this.closeModalsOnChangeShipping();
            var isBopisProductsPersonalized = this.isBopisProductsPersonalized();
            var isOnlyStoreAvailable = this.isOnlyStoreAvailable();
            var isRecurrentUser = this.isRecurrentUser();
            var recurrentShippingType = this.getRecurrentShippingType();
            var isShippingMismatch = this.evaluateShippingMismatch(recurrentShippingType);
            var isStoreMismatch = this.isStoreMismatch();
            var isBopisSession = this.isBopisSession();
            var hasRecurrentBopisAnyStoreDispoStock = this.hasRecurrentBopisAnyStoreDispoStock();
            var isPromoInBasket = this.isPromoInBasket();
            var dispoResponseObj = $('#dispoResponseObj').val() ? JSON.parse($('#dispoResponseObj').val()) : null;
            var hasOnlyStoreProducts = this.hasOnlyStoreProducts();
            var hasOnlyMainProducts = this.hasOnlyMainProducts();

            console.log('[BOPIS VARIABLES]', {
                isBopisProductsPersonalized,
                isOnlyStoreAvailable,
                isRecurrentUser,
                isShippingMismatch,
                isStoreMismatch,
                isBopisSession,
                hasRecurrentBopisAnyStoreDispoStock,
                isPromoInBasket,
                dispoResponseObj,
                recurrentShippingType,
                hasOnlyStoreProducts: hasOnlyStoreProducts,
                hasOnlyMainProducts: hasOnlyMainProducts
            });
        }
    }

    bindCartEvents () {
        $('body').on('click', '#checkout-button-secure-checkout, .js-ModalExpressButton-paypal, .js-ModalExpressButton-amazonPay, .js-ModalExpressButton-klarna', (e) => {
            e.preventDefault();
            var isBopisProductsPersonalized = this.isBopisProductsPersonalized();
            var isOnlyStoreAvailable = this.isOnlyStoreAvailable();
            var isRecurrentUser = this.isRecurrentUser();
            var isRecurrentStoreBopis = this.isRecurrentStoreBopis();
            var recurrentShippingType = this.getRecurrentShippingType();
            var isShippingMismatch = this.evaluateShippingMismatch(recurrentShippingType);
            var isStoreMismatch = this.isStoreMismatch();
            var isBopisSession = this.isBopisSession();
            var hasRecurrentBopisAnyStoreDispoStock = this.hasRecurrentBopisAnyStoreDispoStock();
            var isPromoInBasket = this.isPromoInBasket();

            if (isRecurrentUser) {
                if (isBopisProductsPersonalized) {
                    e.stopImmediatePropagation();
                    // modal1
                    this.openRemoveCustomizationModal(e.currentTarget);
                }
                if (isShippingMismatch && isOnlyStoreAvailable && !isBopisProductsPersonalized) {
                    e.stopImmediatePropagation();
                    // modal5
                    this.openRecurrentNotCompatibleDeliveryModal();
                    return;
                }
                if (isRecurrentStoreBopis && !isBopisSession && !hasRecurrentBopisAnyStoreDispoStock && !isOnlyStoreAvailable && !isBopisProductsPersonalized) {
                    e.stopImmediatePropagation();
                    // modal7
                    this.openRecurrentNotCompatibleMixedModal();
                    return;
                }
                if (isShippingMismatch && !isOnlyStoreAvailable && !isBopisProductsPersonalized) {
                    e.stopImmediatePropagation();
                    if (isPromoInBasket) {
                        // modal4
                        this.openPromoShippingMismatchModal(recurrentShippingType, e.currentTarget);
                    } else {
                        // modal2
                        this.openShippingMismatchModal(recurrentShippingType, e.currentTarget);
                    }
                    return;
                }
                if (isStoreMismatch && !isShippingMismatch && !isBopisProductsPersonalized && recurrentShippingType === 'bopis') {
                    e.stopImmediatePropagation();
                    // modal6
                    this.openRecurrentNotCompatibleStoreModal();
                }
            } else {
                if (isBopisProductsPersonalized) {
                    e.stopImmediatePropagation();
                    // modal1: rimozione personalizzazione
                    this.openRemoveCustomizationModal(e.currentTarget);
                }
            }
        });
        $('body').on('click', '.js-ModalExpressButton-applePay', (e) => {
            e.preventDefault();
            var isValidShippingMethod = this.validateShippingMethod('courier', null, e.currentTarget);
            if (!isValidShippingMethod) {
                e.stopImmediatePropagation();
            }
        });
    }

    triggerShippingIfNeeded () {
        if (new URL(location).searchParams.get('shippingTriggered') === 'true') {
            $('.submit-shipping').trigger('click');
            const url = new URL(window.location.href);
            url.searchParams.delete('shippingTriggered');
            window.history.replaceState({}, document.title, url.toString());
        }
    }

    validateShippingMethod (shippingMethodType, notBopisProducts, triggerButton) {
        if (!this.isBopisOnlyActive()) {
            return true;
        }
        var isPromoInBasket = this.isPromoInBasket();
        var isShippingMismatch = this.evaluateShippingMismatch(shippingMethodType, notBopisProducts);
        console.log('[BOPIS VARIABLES]', {
            isShippingMismatch,
            isPromoInBasket
        });

        if (isShippingMismatch) {
            if (isPromoInBasket) {
                // modal4
                this.openPromoShippingMismatchModal(shippingMethodType, triggerButton, notBopisProducts);
            } else {
                // modal2
                this.openShippingMismatchModal(shippingMethodType, triggerButton, notBopisProducts);
            }
            return false;
        }
        return true;
    }

    validateShippingCardClick (isShippingSelectedBopis, triggerButton) {
        if (!this.isBopisOnlyActive()) {
            return true;
        }
        // var isPersonalizedBasket = this.isPersonalizedBasket();
        var isBopisProductsPersonalized = this.isBopisProductsPersonalized();
        console.log('[BOPIS VARIABLES]', {
            isBopisProductsPersonalized,
            isShippingSelectedBopis
        });

        if (isBopisProductsPersonalized && isShippingSelectedBopis) {
            // modal3
            this.openRemoveCustomizationShippingModal(triggerButton);
            return false;
        }
        return true;
    }

    bindPickupPointEvents () {
        if (!this.isBopisOnlyActive()) {
            return;
        }
        $('body').on('click', '[class*="js-choose-pickupPoint"]', (e) => {
            var isPromoInBasket = this.isPromoInBasket();
            var isShippingMismatch = this.evaluateShippingMismatch('pickup');

            if (isShippingMismatch) {
                e.preventDefault();
                e.stopImmediatePropagation();
                if (isPromoInBasket) {
                    // modal4
                    this.openPromoShippingMismatchModal('pickup', e.currentTarget);
                } else {
                    // modal2
                    this.openShippingMismatchModal('pickup', e.currentTarget);
                }
                // this.closeMapModal();
                return false;
            }
            return true;
        });
    }

    closeModalsOnChangeShipping () {
        $('.cc-cart-show').off('click', '.js-bopis-modal-btn-change-shipping').on('click', '.js-bopis-modal-btn-change-shipping', (e) => {
            if ($('.express-modal-fast-checkout').css('visibility') === 'visible') {
                e.preventDefault();
                e.stopImmediatePropagation();
                $(e.currentTarget).closest('.cc-bopis-modal').find('.modal-header .close').trigger('click');
                if ($('.tingle-modal.findinstore').css('visibility') === 'visible') {
                    $('.tingle-modal.findinstore .findinstore-close').trigger('click');
                }
            }
        });
    }

    // 1. Checkout: remove personalization
    // Actions: Remove
    openRemoveCustomizationModal (triggerButton) {
        const modal = this.openModalFromTemplate('#removeCustomizationModal', 'center');
        // this.attachImageToRemovePersonalizationModal(modal);
        $(modal.modalBox).on('click', '.js-remove-personalization', e => {
            e.preventDefault();
            this.removePersonalization(modal, triggerButton);
        });
    }

    // 2. Shipping mismatch with BOPIS info
    // Actions: Move to wishlist or Change shipping method
    openShippingMismatchModal (shippingMethodType, triggerButton, notBopisProducts) {
        const modal = this.openModalFromTemplate('#shippingMismatchModal');
        this.attachImageToShippingMismatchModal(modal, shippingMethodType, notBopisProducts);
        $(modal.modalBox).on('click', '.js-add-wishlist-and-remove', e => {
            e.preventDefault();
            this.addWishlistAndRemove(shippingMethodType, modal, triggerButton, notBopisProducts);
            if ($('.js-bopis-toast .js-multiple-product').length > 0) {
                $('.js-bopis-toast .cc-bopis-toast__products').addClass('cc-bopis-toast__products--multiple');
            }
            $('.js-bopis-toast').addClass('cc-visible');
        });

        $('body').on('click', '.js-bopis-toast-close', e => {
            e.preventDefault();
            $(e.currentTarget).closest('.js-bopis-toast').removeClass('cc-visible');
        });
    }

    // 3. Shipping card click: remove personalization
    // Actions: Remove or Change shipping method
    openRemoveCustomizationShippingModal (triggerButton) {
        const modal = this.openModalFromTemplate('#removeCustomizationModal', 'center');
        // this.attachImageToRemovePersonalizationModal(modal);
        $('.js-remove-personalization-n1').addClass('d-none');
        $('.js-remove-personalization-n3').removeClass('d-none');
        $('.js-change-shipping-method').removeClass('hidden');

        $(modal.modalBox).on('click', '.js-remove-personalization', e => {
            e.preventDefault();
            this.removePersonalization(modal, triggerButton);
        });
    }

    // 4. Promo + shipping mismatch with BOPIS info
    // Actions: Move to wishlist or Change shipping method
    openPromoShippingMismatchModal (shippingMethodType, triggerButton, notBopisProducts) {
        const modal = this.openModalFromTemplate('#shippingMismatchModal');
        this.attachImageToShippingMismatchModal(modal, shippingMethodType, notBopisProducts);
        this.attachPromoInfoToShippingMismatchModal(modal);
        this.addBonusProductInModal(modal);
        $(modal.modalBox).on('click', '.js-add-wishlist-and-remove', e => {
            e.preventDefault();
            this.addWishlistAndRemove(shippingMethodType, modal, triggerButton, notBopisProducts);
            if ($('.js-bopis-toast .js-multiple-product').length > 0) {
                $('.js-bopis-toast .cc-bopis-toast__products').addClass('cc-bopis-toast__products--multiple');
            }
            $('.js-bopis-toast').addClass('cc-visible');
        });

        $('body').on('click', '.js-bopis-toast-close', e => {
            e.preventDefault();
            $(e.currentTarget).closest('.js-bopis-toast').removeClass('cc-visible');
        });
    }

    // 5. Recurrent not compatible → BOPIS only products, invalid shipping (home-delivery)
    // Actions: Change shipping method
    openRecurrentNotCompatibleDeliveryModal () {
        const modal = this.openModalFromTemplate('#recurrentNotCompatibleDeliveryModal');
        this.attachImageToNotCompatibleStoreModal(modal);
        $(modal.modalBox).on('click', '.js-remove-recurrent', e => {
            e.preventDefault();
            this.goToCheckoutWithoutRecurrent(modal);
        });
    }

    // 6. Recurrent not compatible → store not BOPIS
    // Actions: Change store
    openRecurrentNotCompatibleStoreModal () {
        const modal = this.openModalFromTemplate('#recurrentNotCompatibleStoreModal', 'center');
        this.callNotCompatibleStoreModal(modal);
    }

    // 7. Recurrent not compatible → products NOT only BOPIS + invalid store
    // Actions: Change store or Change shipping method
    openRecurrentNotCompatibleMixedModal () {
        const modal = this.openModalFromTemplate('#recurrentNotCompatibleMixedModal', 'center');
        this.callNotCompatibleStoreModal(modal);
        /* $(modal.modalBox).on('click', '.js-change-store', e => {
            e.preventDefault();
            $('body').removeClass('bopis-modal-open');
            modal.close();
            modal.destroy();
        });
        */
        $(modal.modalBox).on('click', '.js-remove-recurrent', e => {
            e.preventDefault();
            this.goToCheckoutWithoutRecurrent(modal);
        });
    }

    openModalFromTemplate (templateSelector, alignment = 'right') {
        const htmlContent = $(templateSelector).clone().html();

        const modal = newModalFromString(htmlContent, false);
        $(modal.modal).addClass('bopisModal cc-bopis-modal');
        $(modal.modalBox).addClass(alignment === 'center' ? 'centeredModalAttribute' : 'rightModalAttribute');
        modal.open();
        $('body').addClass('bopis-modal-open');

        $(modal.modalBox).on('click', '.close, .btn-close', (e) => {
            e.preventDefault();
            $('body').removeClass('bopis-modal-open');
            modal.close();
            modal.destroy();
        });

        return modal;
    }

    isPersonalizedBasket () {
        return ($('.personalization-item').length > 0 || $('.personalized-attributes').length > 0);
    }

    isBopisProductsPersonalized () {
        var bopisProducts = $('#storeSkus').val().replace(/\[|\]/g, '').split(', ');
        var personalizedProducts = this.getPersonalizedItems();

        return bopisProducts.some(r => personalizedProducts.indexOf(r) >= 0);
    }

    isBopisActive () {
        return ($('.store-info').hasClass('is-bopis'));
    }

    isPromoInBasket () {
        return ($('#isPromoInBasket').val() === 'true');
    }

    isRecurrentUser () {
        return ($('#isRecurrentUser').val() === 'true' && $('#recurrentShippingType').val() !== '' && $('#recurrentShippingType').val() !== 'null');
    }

    isRecurrentStoreBopis () {
        return ($('#isRecurrentStoreBopis').val() === 'true');
    }

    isOnlyStoreAvailable () {
        return ($('#isOnlyStoreAvailable').val() === 'true');
    }

    isOnlyMainAvailable () {
        return ($('#isOnlyMainAvailable').val() === 'true');
    }

    hasOnlyStoreProducts () {
        const numOfStore = this.getOnlyStoreSkus().length;
        return (numOfStore > 0);
    }

    hasOnlyMainProducts () {
        const numOfMain = this.getOnlyMainSkus().length;
        return (numOfMain > 0);
    }

    getOnlyStoreSkus () {
        var storeSkus = $('#storeSkus').val().replace(/\[|\]/g, '');
        var mainSkus = $('#mainSkus').val().replace(/\[|\]/g, '');
        var onlyStoreSkus = storeSkus.split(', ').filter(sku => !mainSkus.includes(sku));
        return onlyStoreSkus;
    }

    getOnlyMainSkus () {
        var storeSkus = $('#storeSkus').val().replace(/\[|\]/g, '');
        var mainSkus = $('#mainSkus').val().replace(/\[|\]/g, '');
        var onlyMainSkus = mainSkus.split(', ').filter(sku => !storeSkus.includes(sku));
        return onlyMainSkus;
    }

    isShippingMismatch () {
        return this.isOnlyStoreAvailable() && this.isRecurrentCourierDelivery();
    }

    evaluateShippingMismatch (shippingMethodType, notBopisProducts) {
        if (shippingMethodType === 'bopis' && notBopisProducts && notBopisProducts.length > 0) {
            return true;
        } else {
            var hasOnlyStoreProducts = this.hasOnlyStoreProducts();
            var hasOnlyMainProducts = this.hasOnlyMainProducts();
            return (
                (hasOnlyStoreProducts && shippingMethodType === 'courier') ||
                (hasOnlyStoreProducts && shippingMethodType === 'store') ||
                (hasOnlyStoreProducts && shippingMethodType === 'pickup') ||
                (hasOnlyMainProducts && shippingMethodType === 'bopis')
            );
        }
    }

    isStoreMismatch () {
        return !this.isBopisSession();
    }

    isBopisSession () {
        return ($('#isBopisSession').val() === 'true');
    }

    isBopisRecurrent () {
        return ($('#isBopisRecurrent').val() === 'true');
    }

    isRecurrentCourierDelivery () {
        return ($('#isRecurrentCourierDelivery').val() === 'true');
    }

    isBopisOnlyActive () {
        return ($('#isBopisOnlyActive').val() === 'true');
    }

    isCartPage () {
        return $('.page').data('action').indexOf('Cart') !== -1;
    }

    isCheckoutPage () {
        return $('.page').data('action').indexOf('Checkout') !== -1;
    }

    hasRecurrentBopisAnyStoreDispoStock () {
        return ($('#hasRecurrentBopisAnyStoreDispoStock').val() === 'true');
    }

    getRecurrentShippingType () {
        if (this.isBopisRecurrent()) {
            return 'bopis';
        } else {
            return $('#recurrentShippingType').val() === 'pickupInStore' ? 'store' : $('#recurrentShippingType').val();
        }
    }

    getPersonalizedItems () {
        var personalizedItems = $('#personalizedItems').val().replace(/\[|\]/g, '');
        if (personalizedItems.length > 0) {
            return personalizedItems.split(',');
        }
        return [];
    }

    attachImageToShippingMismatchModal (modal, shippingMethodType, notBopisProducts) {
        var imageToCopy = shippingMethodType === 'bopis' ? '.js-image-availability-recap.main-only-image' : '.js-image-availability-recap.store-only-image';
        if (notBopisProducts && notBopisProducts.length > 0) {
            imageToCopy = notBopisProducts;
            $(modal.modalBox).find('.js-image-wrapper').html($(imageToCopy).clone());
            $('.js-bopis-toast .js-image-wrapper').html($(imageToCopy).clone());
            $(modal.modalBox).find('.not-bopis-products-images').removeClass('hidden');
        } else {
            $(modal.modalBox).find('.js-image-wrapper').html($(imageToCopy).clone()[0]);
            $('.js-bopis-toast .js-image-wrapper').html($(imageToCopy).clone()[0]);
            $(modal.modalBox).find('.js-image-availability-recap').removeClass('hidden');
        }
    }

    addBonusProductInModal (modal) {
        if ($('.cc-productWrapper-container_bonus').length > 0) {
            var bonusAlert = $('.js-alert-bonus-product').html();
            if ($(modal.modalBox).find('.js-image-wrapper > .js-image-availability-recap .cc-bopis-product').length === 0) {
                $(modal.modalBox).find('.cc-bopis-modal__alert').hide();
                $(modal.modalBox).find('.cc-bopis-modal__btn-secondary').hide();
                $(modal.modalBox).find('.js-image-wrapper').append(bonusAlert).clone();
                $(modal.modalBox).find('.cc-alert-bonus-in-modal').addClass('cc-only-child');
            } else {
                $(modal.modalBox).find('.js-image-wrapper').append(bonusAlert).clone();
            }

            $('.cc-productWrapper-container_bonus').each(function () {
                var bonusProductImageSrc = $(this).find('.cc-productWrapper-image').attr('src');
                var bonusProductPid = $(this).find('.line-item-pid .cc-productWrapper-productInfo-productCode').text().trim();
                var bonusProductName = $(this).find('.line-item-name .cart-product-name').text().trim();

                var bonusHtml = `
                    <div class="cc-bopis-product">
                        <div class="cc-bopis-product__img">
                            <img class="product-image" src="${bonusProductImageSrc}" data-product-id="${bonusProductPid}" data-product-name="${bonusProductName}" />
                        </div>
                        <div class="cc-bopis-product__info">
                            <span class="cc-bopis-product__id js-product-id">${bonusProductPid}</span>
                            <span class="cc-bopis-product__name">${bonusProductName}</span>
                        </div>
                    </div>
                `;

                $(modal.modalBox).find('.js-image-wrapper').append(bonusHtml);
            });
        }
        var bonusProductImage = $('.js-bonus-product-image').clone();
        $('.js-bonus-product-image-modal').html(bonusProductImage);
    }

    attachImageToRemovePersonalizationModal (modal) {
        var imageToCopy = $('.checkout-product[data-item_customization="customized"]').siblings('.cc-productWrapper-container');
        $(modal.modalBox).find('.js-image-wrapper').html($(imageToCopy).clone());
    }

    attachPromoInfoToShippingMismatchModal (modal) {
        $(modal.modalBox).find('.js-modal-title-no-promo').addClass('d-none');
        $(modal.modalBox).find('.js-alert-text-no-promo').addClass('d-none');
        $(modal.modalBox).find('.js-modal-title-promo').removeClass('d-none');
        $(modal.modalBox).find('.js-alert-text-promo').removeClass('d-none');
    }

    attachImageToNotCompatibleStoreModal (modal) {
        var imageToCopy = $('.cc-productWrapper-container');
        var imageToCopyModal = $('.js-image-availability-recap.store-only-image');
        $(modal.modalBox).find('.js-image-wrapper').html($(imageToCopyModal).clone());
        $(modal.modalBox).find('.js-image-availability-recap').removeClass('hidden');
        $('.js-bopis-toast .js-image-wrapper').html($(imageToCopy).clone());
    }

    closeMapModal () {
        $('.pickuppoint-wrapper .modal-close').trigger('click');
    }

    redirectWithShippingTriggered (triggerButton) {
        var modalOpened = '';
        if (this.isCartPage()) {
            if ($('.paypal-confirm-express').attr('style') && $('.paypal-confirm-express').css('display') !== 'none') {
                modalOpened = 'paypal';
            } else if ($('.amazon-confirm-express').attr('style') && $('.amazon-confirm-express').css('display') !== 'none') {
                modalOpened = 'amazon';
            } else if ($('.klarna-confirm-express').attr('style') && $('.klarna-confirm-express').css('display') !== 'none') {
                modalOpened = 'klarna';
            } else {
                return;
            }
        }
        let redirectUrl = window.location.href.split('#')[0];
        const fragment = window.location.hash;
        redirectUrl += (redirectUrl.indexOf('?') > -1 ? '&' : '?') + 'shippingTriggered=true';
        // personalizationRemoved to reuse code that already exists
        redirectUrl += (modalOpened ? '&personalizationRemoved=' + modalOpened : '');
        redirectUrl += fragment;
        window.location.href = redirectUrl;
    }

    callNotCompatibleStoreModal (modal) {
        const url = $('#notCompatibleStoreModalUrl').val();
        const storeId = $('#storeInfoStoreId').val();
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'POST',
            data: {storeId: storeId},
            success: data => {
                $('.js-find-in-store-wrapper').html(data.findInStoreSummary).removeClass('hide');
                this.addCloseModalListener(modal);
                FindInStore.run(false);
                var storeBlock = FindInStore.renderStoreBlock(data);
                var storeData = FindInStore.renderResultWithTemplate(data, null, null, storeBlock);
                $('.js-store-wrapper').html(storeData);
                StoreHours.run();
                $.spinner().stop();
            }
        });
    }

    removePersonalization (modal, triggerButton) {
        const url = $('#removePersonalizationUrl').val();
        const payload = {};

        $.spinner().start();

        $.ajax({
            url: url,
            method: 'POST',
            data: payload,
            success: data => {
                $('.personalization-item').remove();
                $('.fnCartOptions-personalization').hide();
                $('.personalized-attributes').remove();
                $('.personalizationAlert').hide();
                $('.personalization-row').hide();
                $('.total-box-body-item .grand-total-sum').text(data.totalGrossPrice);
                $('.cc-personalizeDetails').remove();
                $('.cc-pers-long-description').remove();
                $('#personalizedItems').val('');

                $.spinner().stop();
                let actionType = 'checkout';
                if ($(triggerButton).is('.js-ModalExpressButton-paypal')) {
                    actionType = 'paypal';
                } else if ($(triggerButton).is('.js-ModalExpressButton-amazonPay')) {
                    actionType = 'amazon';
                } else if ($(triggerButton).is('.js-ModalExpressButton-klarna')) {
                    actionType = 'klarna';
                } else if ($(triggerButton).is('.js-shipping-types')) {
                    actionType = 'bopisSelection';
                }

                if (actionType === 'checkout') {
                    // $('#storeSkus').val('');
                    $(triggerButton).trigger('click');
                } else if (actionType === 'bopisSelection') {
                    $('#storeSkus').val('');
                    $(triggerButton).trigger('click');
                    $('.js-find-in-store-btn.js-is-bopis-btn.js-select-store').trigger('click');
                } else {
                    let redirect = window.location.href.split('#')[0];
                    const fragment = window.location.hash;

                    redirect += (redirect.indexOf('?') > -1 ? '&' : '?') + 'personalizationRemoved=' + actionType;
                    redirect += fragment;

                    window.location.href = redirect;
                }
            },
            error: () => {
                $.spinner().stop();
            }
        }).then(() => {
            $.spinner().stop();
        });

        $('body').removeClass('bopis-modal-open');
        modal.close();
        modal.destroy();
    }

    addWishlistAndRemove (shippingMethodType, modal, triggerButton, notBopisProducts) {
        const url = $('#addtoWishlistAndRemoveUrl').val();
        var storeProducts = this.getOnlyStoreSkus().join(',');
        var mainProducts = this.getOnlyMainSkus().join(',');
        var notBopisIds = notBopisProducts && notBopisProducts.map(function () {
            return $(this).find('.js-product-id').text().trim();
        }).get().join(',');
        var productsToRemove = (notBopisProducts !== undefined && notBopisProducts !== null && notBopisProducts.length > 0) ? notBopisIds : (shippingMethodType === 'bopis' ? mainProducts : storeProducts);

        $.spinner().start();

        $.ajax({
            url: url,
            method: 'POST',
            data: {products: productsToRemove},
            success: (data) => {
                // this.showNotification();
                if (shippingMethodType === 'bopis') {
                    $('#mainSkus').val('');
                    $('.not-bopis-products-images').not('.js-bopis-toast .not-bopis-products-images').remove();
                } else {
                    $('#storeSkus').val('');
                }
                if (data.isPersonalizedBasket === false) {
                    $('.personalization-item').remove();
                    $('.fnCartOptions-personalization').hide();
                    $('.personalized-attributes').remove();
                    $('.personalizationAlert').hide();
                    $('.personalization-row').hide();
                }

                $('#isBopisSession').val(data.isBopisSession);
                $('#hasRecurrentBopisAnyStoreDispoStock').val(data.isBopisSession);

                // Trigger GA event for adding the products to the wishlist
                let skuArray = shippingMethodType === 'bopis' ? (notBopisIds ? notBopisIds.split(',') : []) : storeProducts.split(',');
                if (skuArray.length === 1) {
                    $('body').trigger('wishlist:add', { sku: skuArray[0], sender: 'checkout' });
                } else if (skuArray.length > 1) {
                    $('body').trigger('wishlist:add-multiple', { skuArray: skuArray, sender: 'checkout' });
                }
                var isFindInStoreModalOpen = $('.findinstore-data-container').hasClass('tingle-modal--visible');
                if (isFindInStoreModalOpen) {
                    $('.findinstore-results .selected').find('.js-choose-store').trigger('click');
                }
                $('#redirectWithShippingTriggered').val('true');
                $(triggerButton).trigger('click');
                $('.submit-shipping').trigger('click');
                var isExpressModalOpen = $('.express-button-modal').hasClass('tingle-modal--visible');
                if (isExpressModalOpen) {
                    $('.js-expressButtonContinue').trigger('click');
                }

                setTimeout(() => {
                    this.redirectWithShippingTriggered(triggerButton);
                }, 100);
            },
            error: () => {
                $.spinner().stop();
            }
        }).then(() => {
            $.spinner().stop();
        });

        $('body').removeClass('bopis-modal-open');
        modal.close();
        modal.destroy();
    }

    goToCheckoutWithoutRecurrent (modal) {
        let url = $('#checkout-button-secure-checkout').attr('data-url');
        url += (url.indexOf('?') > -1 ? '&' : '?') + 'preventRecurrentFlow=true';

        $.spinner().start();
        window.location.href = url;
        
        $('body').removeClass('bopis-modal-open');
        modal.close();
        modal.destroy();
    }

    clickOnAccordion () {
        $('body').off('click', '.js-bopis-accordion-btn').on('click', '.js-bopis-accordion-btn', (e) => {
            e.preventDefault();
            e.stopImmediatePropagation();
            $(e.currentTarget).closest('.js-bopis-accordion-wrp').toggleClass('is-open');
            $(e.currentTarget).closest('.js-bopis-accordion-wrp').find('.js-bopis-accordion-content').slideToggle(220);
            const isExpanded = $(e.currentTarget).closest('.js-bopis-accordion-wrp').hasClass('is-open');
            if (isExpanded) {
                $(e.currentTarget).attr('aria-expanded', 'true');
                $(e.currentTarget).closest('.js-bopis-accordion-wrp').find('.js-bopis-accordion-content').attr('aria-hidden', 'false');

                // #region open_accordion GA event
                // Trigger the GA event for opening the accordion

                // The label of the accordion
                let accordionLabel = $(e.currentTarget).find('.js-bopis-accordion-title').data('accordion-label').trim().toLowerCase().replaceAll(' ', '_') || '';

                let shippingMethodContainer = $(e.currentTarget).closest('.js-shipping-types');
                let shippingMethod = shippingMethodContainer.find('.js-shipping-method');

                // Check the shipping method type
                var shippingMethodType = 'courier_delivery';
                if (shippingMethod.attr('data-pickup') === 'true') {
                    shippingMethodType = 'store_pickup';
                } else if (shippingMethod.attr('data-pickup-point') === 'true') {
                    shippingMethodType = 'pickup_point';
                }

                // Check if it is express or standard
                // In the case of store pickup, the Bopis method is considered express
                var isShippingMethodBopis = shippingMethodContainer.hasClass('js-is-bopis');
                if (
                    (shippingMethodType === 'store_pickup' && isShippingMethodBopis) ||
                    (shippingMethodType !== 'store_pickup' && shippingMethod.attr('data-is-express-shipping') === 'true')
                ) {
                    shippingMethodType = 'express_' + shippingMethodType;
                } else {
                    shippingMethodType = 'standard_' + shippingMethodType;
                }

                $('body').trigger('checkout:openShippingAvailabilityAccordion', {accordionLabel: accordionLabel, shippingType: shippingMethodType});
                // #endregion
            } else {
                $(e.currentTarget).attr('aria-expanded', 'false');
                $(e.currentTarget).closest('.js-bopis-accordion-wrp').find('.js-bopis-accordion-content').attr('aria-hidden', 'true');
            }
        });
    }

    addCloseModalListener (modal) {
        $('body').off('click', '.js-find-in-store-btn').on('click', '.js-find-in-store-btn', () => {
            $('body').removeClass('bopis-modal-open');
            modal.close();
            modal.destroy();
        });
    }
}

const bopisHelpers = new BopisHelpers();
export default bopisHelpers;
